import { render } from "./SearchStudentForm.vue?vue&type=template&id=37a5bf54&scoped=true"
import script from "./SearchStudentForm.vue?vue&type=script&lang=js"
export * from "./SearchStudentForm.vue?vue&type=script&lang=js"

import "./SearchStudentForm.vue?vue&type=style&index=0&id=37a5bf54&scoped=true&lang=css"

import exportComponent from "D:\\EME_MARKETING_AND_CONSULTING\\_Proyectos\\bookapps\\Apps Code\\web-admin-bookapps-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a5bf54"]])

export default __exports__